export default __webpack_public_path__ + "static/media/email-browse.8e0df89c.png";